/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "mobx-react";
import Store from "./store";
import { SnackbarProvider } from "notistack";
import { ApolloProvider } from "@apollo/client";
import { WagmiConfig } from "wagmi";
import { wagmiClient } from "./web3modal";
import { useApollo } from "./apollo/client";

// const client = new ApolloClient({
//   link: wsLink,
//   cache: new InMemoryCache(),
//   defaultOptions: {
//     watchQuery: {
//       fetchPolicy: "no-cache",
//       errorPolicy: "ignore",
//     },
//     query: {
//       fetchPolicy: "no-cache",
//       errorPolicy: "all",
//     },
//   },
// });
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const InitApp = () => {
  const apolloClient = useApollo({ __APOLLO_STATE__: "state" });
  return (
    <Provider {...new Store().getStores()}>
      <ApolloProvider client={apolloClient}>
        <SnackbarProvider>
          <WagmiConfig config={wagmiClient}>
            <App />
          </WagmiConfig>
        </SnackbarProvider>
      </ApolloProvider>
    </Provider>
  );
};
root.render(<InitApp />);

reportWebVitals();
